import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from '@/shared/constants/routes';
import { SALES_CALENDAR_URL } from '@/shared/constants/sales';
import { useTrans } from '@/shared/hooks/useTranslation';
import { usePermissions } from '@/viewmodel/features/project';
import type { NotifyAction } from '@/viewmodel/shared/notify';

export function usePlanLimitToastAction(): NotifyAction {
  const { t } = useTrans();
  const { can } = usePermissions();
  const navigate = useNavigate();
  const canViewBilling = can('billing:view');

  return useMemo(
    () =>
      canViewBilling
        ? { label: t('planLocked.viewPlans'), onPress: () => navigate(ROUTES.BILLING) }
        : {
            label: t('dataset.tablesLimit.talkToSales'),
            onPress: () => window.open(SALES_CALENDAR_URL, '_blank', 'noopener,noreferrer'),
          },
    [canViewBilling, t, navigate],
  );
}
